import DeleteIcon from '../../../assets/Delete.svg';
import RotateIcon from '../../../assets/Rotate.svg';
import ScaleIcon from '../../../assets/Scale.svg';
import CircleIcon from '../../../assets/circle-icon.svg';
import RectangleIcon from '../../../assets/rectangle-icon.svg';

// Set up icon images
const deleteIcon = new Image();
const rotateIcon = new Image();
const scaleIcon = new Image();
const circleIcon = new Image();
const rectangleIcon = new Image();

deleteIcon.src = DeleteIcon;
rotateIcon.src = RotateIcon;
scaleIcon.src = ScaleIcon;
circleIcon.src = CircleIcon;
rectangleIcon.src = RectangleIcon;

export { deleteIcon, rotateIcon, scaleIcon, circleIcon, rectangleIcon };
